export default __webpack_public_path__ + "static/4-02a52280e284b0464459eb86109cfc46.png";